// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import http from '@/api/http'
import dsBridge from '@/api/dsbridge.js'
import 'lib-flexible/flexible.js'
import api from '@/api/api'
import store from '@/store/index.js'


import { Toast, Popup, Button, NavBar, Field, Lazyload, Col, Row } from 'vant' //已经引入,需要时用
Vue.use(Toast).use(Popup).use(Button).use(Field).use(NavBar).use(Lazyload).use(Col).use(Row);


Vue.config.productionTip = false
Vue.prototype.$axios = http     //封装的axios
Vue.prototype.$dsBridge = dsBridge   //封装的dsBridge
Vue.prototype.$api = api     //统一管理api
Vue.prototype.$imgUrls = 'http://300w.oss-cn-shenzhen.aliyuncs.com/'    //图片地址 https://dc300.netwin.cn/pckm/static/image/ (正式)

window.addEventListener('popstate', function (e) {
  router.isBack = true
}, false)

var appVue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js